exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-left[data-v-0dc212a7] {\n  width: 10rem;\n}\n.text-line-through[data-v-0dc212a7] {\n  text-decoration: line-through !important;\n}", ""]);

// exports
